import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "france",
  "use": "france-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"france\"><path fill=\"#f0f0f0\" d=\"M0 85.331h512v341.337H0z\" /><path fill=\"#0052b4\" d=\"M0 85.331h170.663v341.337H0z\" /><path fill=\"#d80027\" d=\"M341.337 85.331H512v341.337H341.337z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol